import { useState } from 'react';
import { Slider } from './slider';
import { Card } from '@/containers/LoanInfo/earnings/ShiftPaymentInfo/card';
import s from './index.module.scss';

export const ShiftPaymentInfo = ({ banners = [] }) => {
  const [closed, setClosed] = useState(false);

  return banners.length && !closed ? (
    banners.length > 1 ? (
      <div className={s.wrapper}>
        <Slider slides={banners} setClosed={setClosed} />
      </div>
    ) : (
      <div className={s.wrapper}>
        <Card data={banners[0]} setClosed={setClosed} />
      </div>
    )
  ) : null;
};
